import { useQuery } from '@tanstack/react-query';
import { fetchBlob } from '../api/client';
import { useShop } from '../shop/ShopProvider';

/**
 * Loads an image URL the API handed out (`imageUrl`, `logoUrl`) with the session token. The URL
 * carries a version, so its bytes never change and the object URL is kept for the session.
 */
export function useImageSrc(url: string | null | undefined): {
  src: string | null;
  loading: boolean;
} {
  const image = useQuery({
    queryKey: ['image-src', url ?? ''],
    queryFn: async () => URL.createObjectURL(await fetchBlob(url ?? '')),
    enabled: !!url,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
  return { src: url ? (image.data ?? null) : null, loading: !!url && image.isLoading };
}

/** The shop logo as a loaded image source (for print documents); null without a logo. */
export function useShopLogo(): string | null {
  const { settings } = useShop();
  return useImageSrc(settings?.logoUrl).src;
}
